export default __webpack_public_path__ + "static/media/cultures.cddb387f.svg";